export default function TrustBadges() {
  const badges = [
    { icon: 'ri-shield-check-line', text: 'Zweryfikowane bezpieczeństwo' },
    { icon: 'ri-star-line', text: '4.8 / 5 ocena użytkowników' },
    { icon: 'ri-group-line', text: 'Społeczność 10 000+ użytkowników' },
    { icon: 'ri-refresh-line', text: 'Regularne aktualizacje' },
  ];

  return (
    <section className="py-8 md:py-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {badges.map((badge) => (
            <div key={badge.text} className="flex items-center gap-3 justify-center">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={badge.icon}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}